export default __webpack_public_path__ + "static/media/Best-offer.71d600b8.png";